module.exports = __webpack_public_path__ + "static/valueFun-6e3ca9791dd28d6047239a5d06306db0.png";